const fromString = s => {
  switch (s) {
    case "auto":
      return -1;
    case "century":
      return 0;
    case "decade":
      return 1;
    case "year":
      return 2;
    case "month":
      return 3;
    case "week":
      return 4;
    case "day":
      return 5;
    case "hour":
      return 6;
    case "minute":
      return 7;
    case "second":
      return 8;
    default:
      return -1;
  }
};

const toString = p => {
  switch (p) {
    case -1:
      return "auto";
    case 0:
      return "century";
    case 1:
      return "decade";
    case 2:
      return "year";
    case 3:
      return "month";
    case 4:
      return "week";
    case 5:
      return "day";
    case 6:
      return "hour";
    case 7:
      return "minute";
    default:
      return "second";
  }
};

export default {
  Auto: -1,
  Century: 0,
  Decade: 1,
  Year: 2,
  Month: 3,
  Week: 4,
  Day: 5,
  Hour: 6,
  Minute: 7,
  Second: 8,
  fromString,
  toString
};
